import { DraggableHTab, HTab } from './DraggableHTab';
import styles from './DraggableHTabs.module.scss';

const DraggableHTabs = (props) => {
	const {
		handleReorder,
		items,
		order,
		activeTab,
		handleActiveTab,
		isDraggable,
	} = props;
	return (
		<div className={`${styles.root}`}>
			{order.map((id, idx) => {
				const { name } = items[id];
				if (isDraggable) {
					return (
						<DraggableHTab
							key={id}
							id={id}
							text={name}
							moveCard={handleReorder}
							index={idx}
							active={id === activeTab}
							handleClick={handleActiveTab}
							isDraggable={isDraggable}
						/>
					);
				}
				return (
					<HTab
						isDraggable={isDraggable}
						key={id}
						id={id}
						text={name}
						index={idx}
						active={id === activeTab}
						handleClick={handleActiveTab}
					/>
				);
			})}
		</div>
	);
};

DraggableHTabs.defaultProps = {
	limit: 10,
	isDraggable: true,
	isDisabled: false,
};

export default DraggableHTabs;
